import { render, staticRenderFns } from "./Inscripcion.vue?vue&type=template&id=967d9250&"
import script from "./Inscripcion.vue?vue&type=script&lang=js&"
export * from "./Inscripcion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports